export const whyItMatters = [
  {
    title: 'Unified Digital Commerce',
    description: "ONDC (Open Network for Digital Commerce) is India's revolutionary network connecting sellers directly to multiple buyer apps like Paytm, Meesho, and Magicpin through a single integration.",    
  },
  {
    title: 'Massive Market Access',
    description: "Gain instant visibility to millions of customers across India without needing to list separately on each marketplace or build your own e-commerce platform.",    
  },
  {
    title: 'Lower Customer Acquisition Costs',
    description: "Escape high commission structures of traditional marketplaces and connect directly with customers through an open, interoperable network built for seller success.",    
  },
]

export default whyItMatters;